module.exports = __webpack_public_path__ + "img/lgpd-simplificada.936b89d8.png";